import { COLORS } from '@/constants';
import { FC } from 'react';

type TabMapIconProps = {
  isActive: boolean;
};

export const TabMapIcon: FC<TabMapIconProps> = ({ isActive }) => {
  const color = isActive ? COLORS.orange : COLORS.gray;

  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3333 8.33335V7.68126C18.3333 6.06491 18.3333 5.25675 17.8452 4.7546C17.357 4.25247 16.5713 4.25247 15 4.25247H13.2678C12.5033 4.25247 12.497 4.25099 11.8096 3.90697L9.03324 2.51764C7.87402 1.93755 7.29442 1.64751 6.67697 1.66767C6.05951 1.68783 5.49896 2.01509 4.37786 2.66961L3.35464 3.267C2.53115 3.74776 2.1194 3.98815 1.89302 4.38805C1.66666 4.78796 1.66666 5.27496 1.66666 6.24896V13.0964C1.66666 14.3762 1.66666 15.0161 1.95187 15.3723C2.14166 15.6092 2.40762 15.7685 2.70166 15.8214C3.14354 15.9007 3.68456 15.5849 4.76655 14.9531C5.50129 14.5242 6.20842 14.0787 7.08738 14.1995C7.8239 14.3007 8.50832 14.7654 9.16666 15.0949"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M6.66666 1.66669V14.1667" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
      <path
        d="M12.5 4.16669V7.91669"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2569 18.0696C15.0763 18.2388 14.8348 18.3333 14.5834 18.3333C14.3321 18.3333 14.0906 18.2388 13.9099 18.0696C12.2553 16.5108 10.0379 14.7696 11.1193 12.2415C11.7039 10.8747 13.1074 10 14.5834 10C16.0594 10 17.4629 10.8747 18.0476 12.2415C19.1276 14.7663 16.9157 16.5162 15.2569 18.0696Z"
        stroke={color}
        strokeWidth="1.5"
      />
      <path
        d="M14.5833 13.75H14.5908"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
